"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyTrainerAdminUpdate = void 0;
exports.trainerAdminUpdateSetMock = trainerAdminUpdateSetMock;
exports.trainerAdminUpdate = trainerAdminUpdate;
exports.useMutationTrainerAdminUpdate = useMutationTrainerAdminUpdate;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function trainerAdminUpdateSetMock(mock) {
    setMock = mock;
}
async function trainerAdminUpdate(body, params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(body, params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/v1/admin/trainer/${params.id}`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params, 'trainer-store')
        : client.getRequestConfig(params, 'trainer-store');
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    if ((params.forceStatusCheck) && (await (0, is_down_1.trainerStoreIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { data: body, headers, method: 'PUT', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyTrainerAdminUpdate = 'trainer-store:trainerAdminUpdate:put';
function useMutationTrainerAdminUpdate(mutationOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    return reactQuery.useMutation(mutationFn, Object.assign({ mutationKey: exports.useKeyTrainerAdminUpdate }, mutationOptions));
}
function mutationFn({ body, params }) {
    const promise = trainerAdminUpdate(body, params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=trainer-admin-update.js.map